<template>
  <div v-if="quickCancel" @click="cancelSession" class="selected-close">x</div>
  <div v-else :style="boxHeight" class="cancel">
    <div class="info">
      <span class="time">{{ slotTimeString }}</span>
      <div>
        <span class="title">Cancel session?</span>
        <div @click="exitIsCanceling" class="action">No</div>
        <div @click="cancelSession" class="action confirm">Yes</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CancelSession",
  props: [
    "quickCancel",
    "userID",
    "boxHeight",
    "slotTimeString",
    "slotDateTimeMS",
  ],
  methods: {
    async cancelSession() {
      this.$emit("cancelSession", this.slotDateTimeMS, this.userID);
    },

    exitIsCanceling() {
      console.log("@CANCELSESSION exitiscanceling: ", this.slotDateTimeMS);
      this.$emit("exitIsCanceling", this.slotDateTimeMS);
    },
  },
};
</script>

<style scoped>
@import "../styles/SessionBox.css";
</style>
